import { IssueTypeDetails } from '../model/issue-type-details';
import { IssueType } from '../model/issue-type';
import { Identity } from '@sdbn/appclient';
import { ServiceResponse } from '@sdbn/appclient';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpService } from '@sdbn/appclient';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class IssueTypeAdministrationService {

  constructor(private httpService: HttpService) { }

  public getIssueTypes(): Observable<IssueType[]> {
    return this.httpService.postWithContext<IssueType[]>(environment.issueTypeAdmininEndpoint, {});
  }

  public getIssueTypeDetails(identity: Identity): Observable<IssueTypeDetails> {
    return this.httpService.postWithContext<IssueTypeDetails>(environment.issueTypeAdmininEndpoint + '/details', identity);
  }

  public saveIssueType(details: IssueTypeDetails): Observable<ServiceResponse> {
    return this.httpService.postWithContext<ServiceResponse>(environment.issueTypeAdmininEndpoint + '/save', details);
  }

  public createIssueType(details: IssueTypeDetails): Observable<ServiceResponse> {
    return this.httpService.postWithContext<ServiceResponse>(environment.issueTypeAdmininEndpoint + '/create', details);
  }

  public deleteIssueType(identity: Identity): Observable<ServiceResponse> {
    return this.httpService.postWithContext<ServiceResponse>(environment.issueTypeAdmininEndpoint + '/delete', identity);
  }
}
